import { createElement } from 'react';
import { cart, checkout, CHECKOUT_VIEW, Utilities } from 'core';
import { PaymentView } from 'ui/components';
import { mapperPaymentViews } from './views';
import { PaymentHeader } from './views/PaymentHeader';

const PaymentWidget = () => {
  const {
    rewards: { status: processStatus },
    views: {
      payment: { view },
    },
  } = checkout.hooks.useCheckout();
  const { isLoading } = cart.hooks.useCart();

  const { PAYMENT_CREDIT_CARD_FORM, PAYMENT_ERRORS } = CHECKOUT_VIEW;
  const isViewCreditCardForm = view === PAYMENT_CREDIT_CARD_FORM || view === PAYMENT_ERRORS;

  return processStatus === Utilities.STATUS.RUNNING || isLoading ? (
    <></>
  ) : (
    <PaymentView>
      {!isViewCreditCardForm && <PaymentHeader />}
      {createElement(mapperPaymentViews[view])}
    </PaymentView>
  );
};

export default PaymentWidget;
